import 'src/components/core/InternetConnectionStatus/InternetConnectionStatus.scss';

import React, { useEffect, useState } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import locales from 'src/components/core/InternetConnectionStatus/InternetConnectionStatus.i18n';
import i18n from 'src/libs/i18n';

const b = require('b_').with('internet-connection-status');

const __ = i18n(locales);

export default function InternetConnectionStatus() {
	const [isOffline, setIsOffline] = useState(false);

	useEffect(() => {
		function onOnline() {
			setIsOffline(false);
		}

		function onOffline() {
			setIsOffline(true);
		}

		window.addEventListener('online', onOnline);
		window.addEventListener('offline', onOffline);

		return () => {
			window.removeEventListener('online', onOnline);
			window.removeEventListener('offline', onOffline);
		};
	}, []);

	if (!isOffline) {
		return null;
	}

	return (
		<div className={b()}>
			<OverlayTrigger placement="auto" overlay={<Tooltip id="tooltip-no-internet-icon">{__('noInternet')}</Tooltip>}>
				<svg className={b('no-internet-icon')} height="512" viewBox="0 0 128 128" width="512" xmlns="http://www.w3.org/2000/svg">
					<g>
						<path d="m55.928 70.307 16.251-16.25 16.686-16.687c.025-.023.048-.047.072-.071l10.531-10.531a1.752 1.752 0 0 0 -.073-2.544 53.244 53.244 0 0 0 -75.171 75.176 1.745 1.745 0 0 0 1.255.584h.051a1.749 1.749 0 0 0 1.238-.512l29.069-29.072c.03-.032.063-.06.091-.093zm-8.559 1.387-1.769-1.769a27.339 27.339 0 0 1 11.974-6.214l-4.014 4.014a25.031 25.031 0 0 0 -6.191 3.969zm22.955-20.733a40.164 40.164 0 0 0 -33.569 10.118l-1.769-1.767a42.678 42.678 0 0 1 37.495-10.507zm12.276-12.28a55.227 55.227 0 0 0 -56.462 11.782l-1.767-1.763a57.747 57.747 0 0 1 60.183-11.969zm-56.972 56.976a49.744 49.744 0 0 1 70.029-70.029l-8.415 8.415a61.193 61.193 0 0 0 -66.6 13.4 1.749 1.749 0 0 0 0 2.473l4.24 4.24a1.75 1.75 0 0 0 1.237.513 1.747 1.747 0 0 0 1.237-.514 51.762 51.762 0 0 1 52.494-12.72l-4.463 4.465a46.121 46.121 0 0 0 -44.139 12.158 1.748 1.748 0 0 0 0 2.469l4.24 4.241a1.751 1.751 0 0 0 1.237.512 1.751 1.751 0 0 0 1.239-.515 36.693 36.693 0 0 1 26.036-10.815c1.067 0 2.133.05 3.193.142l-5.452 5.452c-.875.062-1.722.148-2.492.275a30.891 30.891 0 0 0 -17.4 8.836 1.749 1.749 0 0 0 0 2.472l4.152 4.153z" />
						<path d="m64 83.049a7.75 7.75 0 1 0 7.75 7.75 7.759 7.759 0 0 0 -7.75-7.75zm0 12a4.25 4.25 0 1 1 4.25-4.25 4.254 4.254 0 0 1 -4.25 4.25z" />
						<path d="m108.021 24.349c-.686-.768-1.4-1.524-2.124-2.246s-1.482-1.441-2.245-2.123a59.245 59.245 0 0 0 -83.677 83.666 55.192 55.192 0 0 0 4.373 4.374 59.245 59.245 0 0 0 83.673-83.671zm-4.6 79.074a55.744 55.744 0 0 1 -76.737 1.991 51.468 51.468 0 0 1 -4.106-4.105 55.745 55.745 0 0 1 78.734-78.723c.721.643 1.43 1.313 2.109 1.991s1.348 1.388 1.991 2.109h.006a55.746 55.746 0 0 1 -2 76.732z" />
						<path d="m103.766 28.615a1.753 1.753 0 0 0 -1.256-.584 1.7 1.7 0 0 0 -1.287.512l-24.933 24.933h-.005l-12.438 12.442c-.04.036-.077.075-.114.114l-35.2 35.2a1.752 1.752 0 0 0 .073 2.544 53.248 53.248 0 0 0 73.051-2.118 53.221 53.221 0 0 0 2.108-73.041zm-10.178 12.513a57.6 57.6 0 0 1 10.04 7.568l-1.768 1.768a55.32 55.32 0 0 0 -10.1-7.508zm-11.065 11.065c1.1.525 2.209 1.1 3.321 1.76a42.939 42.939 0 0 1 7.17 5.359l-1.769 1.767a39.187 39.187 0 0 0 -10.6-7.008zm-11.644 11.643a27.336 27.336 0 0 1 11.521 6.089l-1.768 1.768a24.868 24.868 0 0 0 -11.842-5.768zm28.3 35.347a49.752 49.752 0 0 1 -66.839 3.188l33.349-33.344c.563.04 1.114.095 1.639.184a21.486 21.486 0 0 1 12.1 6.152 1.75 1.75 0 0 0 1.238.517 1.75 1.75 0 0 0 1.237-.513l4.24-4.24a1.749 1.749 0 0 0 0-2.472 30.98 30.98 0 0 0 -12.443-7.643l4.28-4.28a36.109 36.109 0 0 1 12.046 8.033 1.751 1.751 0 0 0 1.239.515 1.751 1.751 0 0 0 1.237-.512l4.24-4.241a1.748 1.748 0 0 0 0-2.469 46.169 46.169 0 0 0 -9.117-7.112q-1.245-.739-2.489-1.376l4.063-4.063a52 52 0 0 1 11.434 8.65 1.748 1.748 0 0 0 2.474 0l4.24-4.24a1.751 1.751 0 0 0 0-2.474 61.323 61.323 0 0 0 -11.208-8.879l6.212-6.211a49.723 49.723 0 0 1 -3.181 66.83z" />
					</g>
				</svg>
			</OverlayTrigger>
		</div>
	);
}
